'use strict'

import log from 'loglevel'
import { bus } from './common/bus'

const server = `${
  window.location.protocol === 'https:'
    ? 'wss://' + window.location.hostname
    : 'ws://localhost:9000'
}/v2/`
var ws = null

export var store = {
  debug: false,
  state: {
    ws: null,
    logBuffer: '',
    isConnected: false,
    isDead: false,
    isFullscreen: false,
    useVP8: false,
    selectedBuyer: '',
    buyerCodes: []
  },
  subcriptions: [],
  connect() {
    if (store.state.isConnected) {
      return
    }
    let connectCtx = this
    ws = new WebSocket(server)
    connectCtx.state.ws = ws
    ws.onopen = function() {
      log.info('Socket connected')
      store.state.isConnected = true
      store.state.socket = ws

      // connectCtx.send({
      //   action: 'hello',
      //   token: sessionStorage.getItem('id_token')
      // })
    }
    ws.onclose = function() {
      connectCtx.state.isDead = true
      log.warn('Socket GC')
      bus.$emit(
        'failure',
        'Connection is closed, the market is currently offline or a network error occurred.'
      )
    }
    ws.onerror = function(err) {
      log.error('Socket error: ' + err)

      connectCtx.disconnect()
    }
    ws.onmessage = function(event) {
      try {
        let payload = JSON.parse(event.data)
        store.handle(payload)
      } catch (err) {
        log.debug('On message exception: ' + err)

        connectCtx.handleError(event.data)
      }
    }
  },
  disconnect() {
    store.state.socket.close(1000, 'goodbye')
    store.state.isConnected = false
    store.state.socket = null

    log.warn('Socket disconnected')
  },
  handle(payload) {
    if (this.debug) {
      log.debug('Socket handler triggered')
      log.debug(payload)
    }

    let sub = this.subcriptions.find(({ subj }) => subj == payload.action)
    if (sub != null) {
      if (this.debug) {
        log.debug('Subject handled, calling ' + sub.subj + '()')
      }
      sub.cb(payload)
    }
  },
  handleError(error) {
    if (error == 'Login from another device or tab') {
      bus.$emit('warning', error)
    } else if (error == 'Unauthorized') {
      bus.$emit('warning', 'Unauthorized, will logout in 3s')
      setTimeout(function() {
        bus.$emit('auth')
      }, 3000)
    } else {
      bus.$emit('failure', error)
    }
    this.disconnect()
  },
  send(payload) {
    if (this.state.isConnected) {
      ws.send(JSON.stringify(payload))
    } else {
      log.error('Socket failed to send message')
    }
  },
  subscribe(subj, cb) {
    this.subcriptions.push({
      subj: subj,
      cb: cb
    })
  },
  unsubscribe(subj) {
    this.subcriptions = this.subcriptions.filter(function(sub) {
      return sub.subj != subj
    })
  }
}

// Logging and debug
var originalFactory = log.methodFactory
log.methodFactory = function(methodName, logLevel, loggerName) {
  var rawMethod = originalFactory(methodName, logLevel, loggerName)

  return function(message) {
    store.state.logBuffer +=
      '[' +
      methodName +
      '] ' +
      JSON.stringify(message, null, 2).replace(/(^")|("$)/g, '') +
      '\n'
    rawMethod(message)
  }
}
log.setLevel(log.levels.DEBUG, true) // Be sure to call setLevel method in order to apply plugin
